import { RootState } from "src/redux/store";

/**
 * Check if the user has passed the MFA verification
 * on app load.
 */
export function getMfaPrecheck(state: RootState) {
    return state.mfaPrecheck.value;
}
